import React from 'react';

type Props = {
  children: React.ReactNode;
  separator: JSX.Element;
};

export const SeparatorComponent = ({ children, separator }: Props) => {
  // Convert children to an array and filter out null or undefined elements
  const childArray = React.Children.toArray(children).filter((child) => child);

  return (
    <>
      {childArray.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < childArray.length - 1 && separator}
        </React.Fragment>
      ))}
    </>
  );
};
